var ReifendirektMyAccountCleanAddOnJs = (function ($) {

    var ordersLoading = false;

    var accountSettingsTab = '#content_accountSettings';
    var myOrdersTab = '#content_myOrders';
    var deliveryAddress = '#content_deliveryAddresses';
    var myCars = '#content_myCars';

    var initBindingActions = function (editButtonClass,
                                       cancelButtonClass,
                                       editFormClass,
                                       viewFormClass,
                                       formContainerClass,
                                       submitFormClass,
                                       addNewDeliveryAddressButtonClass,
                                       removeDeliveryAddressButtonClass,
                                       deliveryAddressListContainerClass,
                                       addNewMyCarButtonClass,
                                       removeMyCarButtonClass,
                                       myCarListContainerClass) {

        function showAddNewDeliveryAddressLink(viewForm) {
            //TODO Hack
            if (viewForm.length == 0) {
                $(addNewDeliveryAddressButtonClass).show();
            }
        };

        function showAddNewMyCarLink(viewForm) {
            //TODO Hack
            if (viewForm.length == 0) {
                $(addNewMyCarButtonClass).show();
            }
        };

        function closeEditForm(elem) {
            $(formContainerClass).empty();
            $(viewFormClass).show();
            var $editForm = elem.closest(formContainerClass);
            var $viewForm = $editForm.prev(viewFormClass);
            $viewForm.show();

            showAddNewDeliveryAddressLink($viewForm);
            showAddNewMyCarLink($viewForm);
        };

        $(".my-account-container").on("click", editButtonClass, function(e) {
            var $this = $(this);
            closeEditForm($this);
            ajaxCall("GET", $this.data("request-attribute"), "id=" + $this.data("address-attribute"), function (data) {
                var $viewForm = $this.closest(viewFormClass);
                var $editFormContainer = $viewForm.next(formContainerClass);
                $viewForm.hide();
                $editFormContainer.html(data);
                if (SelectCountryCode !== null && SelectCountryCode !== '') {
                    SelectCountryCode.initSelectCountryCode();
                }
            });
        });


        $(".my-account-container").on("click", cancelButtonClass, function(e) {
            closeEditForm($(this));
        });

        function processDataForDeliveryAddresses(elem, data) {
            elem.closest(".refresh_container").replaceWith(data);

            addNewDeliveryAddressClickEvent();
            removeDeliveryAddressClickEvent();

            showAddNewDeliveryAddressLink($());

            $("html, body").animate({scrollTop:0},"fast");
        };

        function processDataForMyCars(elem, data) {
            elem.closest(".refresh_container").replaceWith(data);

            addNewMyCarClickEvent();
            removeMyCarClickEvent();

            showAddNewMyCarLink($());

            $("html, body").animate({scrollTop:0},"fast");
        };


        $(document).on("submit", submitFormClass, function (e) {
            var $this = $(this);

                ajaxCall($this.attr('method'), $this.attr('action'), $this.serialize(), function (data) {
                    if (containsErrors(data)) {
                        $this.closest(formContainerClass).html(data);
                    } else if (e.target.className === "j-submit-form j-submit-delivery-address-form" || e.target.className === "j-submit-form") {
                        if ($this.closest(deliveryAddressListContainerClass).length == 0) {
                            $this.closest(".refresh_container").replaceWith(data);
                        } else {
                            processDataForDeliveryAddresses($this, data);
                        }
                    } else if (e.target.className === "j-submit-form j-submit-my-car-form") {
                        if ($this.closest(myCarListContainerClass).length == 0) {
                            $this.closest(".refresh_container").replaceWith(data);
                        } else {
                            processDataForMyCars($this, data);
                        }
                    }
                });
            e.preventDefault();
        });

        function addNewDeliveryAddressClickEvent() {
            $(addNewDeliveryAddressButtonClass).on("click", function () {
                var $this = $(this);
                var formSurroundingElemTemplate = "<div class='delivery-addresses-list j-delivery-addresses-list'><div class='j-form-container'>@data@</div></div>";

                ajaxCall("GET", $this.data("request-attribute"), "id=null", function (data) {
                    formSurroundingElemTemplate = formSurroundingElemTemplate.replace(/@data@/g, data);
                    $(".j-edit-form-new-address").before(formSurroundingElemTemplate);
                    $this.hide();
                    $("html, body").animate({scrollTop: $(window).height()/3},"slow");

                    if (SelectCountryCode !== null && SelectCountryCode !== '') {
                        SelectCountryCode.initSelectCountryCode();
                    }
                });
            });
        };
        addNewDeliveryAddressClickEvent();

        function addNewMyCarClickEvent() {
            $(addNewMyCarButtonClass).on("click", function () {
                closeEditForm($(".j-submit-my-car-form"));
                $(".j-submit-my-car-form").hide();
                var $this = $(this);
                var formSurroundingElemTemplate = "<div class='my-cars-list j-my-cars-list'><div class='j-form-container'>@data@</div></div>";

                ajaxCall("GET", $this.data("request-attribute"), "id=null", function (data) {
                    formSurroundingElemTemplate = formSurroundingElemTemplate.replace(/@data@/g, data);
                    $(".j-edit-form-new-car").before(formSurroundingElemTemplate);
                    $this.hide();
                    $("html, body").animate({scrollTop: $(window).height()/3},"slow");
                });
            });
        };
        addNewMyCarClickEvent();

        function removeDeliveryAddressClickEvent() {
            $(removeDeliveryAddressButtonClass).on("click", function () {
                var $this = $(this);
                ajaxCall("POST", $this.data("request-attribute"), "id=" + $this.data("address-attribute"), function (data) {
                    processDataForDeliveryAddresses($this, data);
                });
            });
        };
        removeDeliveryAddressClickEvent();

        function removeMyCarClickEvent() {
            $(removeMyCarButtonClass).on("click", function () {
                var $this = $(this);
                ajaxCall("POST", $this.data("request-attribute"), "id=" + $this.data("address-attribute"), function (data) {
                    processDataForMyCars($this, data);
                });
            });
        };
        removeMyCarClickEvent();

    };

    var ajaxCall = function (type, url, callData, successCallback) {
        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";

        $.ajax({
            type: type,
            url: url,
            data: callData,
            beforeSend: function(xhr) {
                xhr.setRequestHeader(header, token);
            }
        }).done(function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }).fail(function (xhr) {
            var redirectPath = xhr.getResponseHeader('redirectPath');
            if (redirectPath && redirectPath.length > 0) {
                window.location.replace(redirectPath);
            } else {
                window.location.replace(window.location.pathname);
            }
        });
    };

    var containsErrors = function (text) {
        var responseText = String(text);
        return responseText && (responseText.length > 0) && $(responseText).find("div.j-errors-on-page").length > 0;
    };

    var errorsOnPageAction = function (accountDetailsSel, viewEditGroupSel) {
        var errorsOnPage = $(accountDetailsSel).find("div.j-errors-on-page");
        if (errorsOnPage.length > 0) {
            var $firstError = $(errorsOnPage[0]);
            var $parent = $firstError.closest(viewEditGroupSel);
            var $groupToHide = $parent.siblings(viewEditGroupSel);

            $parent.show();
            $groupToHide.hide();

            $('#myAccountTabs a[href="' + accountSettingsTab + '"]').tab('show');

        }
    };

    var initScrollAction = function (tabSel) {
        var currentPage = 0;
        getOrders(currentPage++);
        scrollAction(tabSel, currentPage);
    };

    var scrollAction = function(tabSel, currentPage) {
        var maxPage = $(myOrdersTab).data("max-page");

        $(window).on("scroll", (function(event) {
            if ($(tabSel).hasClass("active")) {
                if (currentPage < maxPage && ordersLoading == false) {
                    if($(window).scrollTop() + $(window).height() == $(document).height()) {
                        getOrders(currentPage++);
                    }
                }
            }
        }));
    };

    function initPrintInvoiceButton() {
        $(".my-account-print-invoice-button").on('click', function (event) {
            event.preventDefault();
            var invoiceUrl = $(this).data("invoice-url");

            if (!invoiceUrl) {
                return;
            }

           window.open(invoiceUrl);
        });
    }

    var getOrders = function(currentPage) {
        if ($(myOrdersTab).length > 0) {
            $(".order-details-empty").hide();
            ordersLoading = true;

            $.ajax({
                url: $(myOrdersTab).data("orders-url"),
                type: "GET",
                cache: true,
                data: { page: currentPage },
                success: function (data) {
                    if ("" == data && currentPage == 0) {
                        $(".order-details-empty").show();
                    } else {
                        $(".order-continuous").append($("<div>").addClass('order-details-data').html(data));
                        initPrintInvoiceButton();
                    }
                },
                complete: function() {
                    ordersLoading = false;
                }
            });
        }
    };

    let initPaginate = function (tabSel) {
        let currentPage = 1;

        let itemsPerPage = localStorage.getItem('itemsPerPage') || 10;
        $('#myOrders_itemsPerPage').val(itemsPerPage);

        let startDate = localStorage.getItem('startDate') || '';
        $('#myOrders_startDate').val(startDate);

        let endDate = localStorage.getItem('endDate') || '';
        $('#myOrders_endDate').val(endDate);

        let searchNumber = localStorage.getItem('searchNumber') || '';
        $('#myOrders_searchNumber').val(searchNumber);

        $("#myOrders_startDate").datepicker({
            dateFormat: "yy-mm-dd",
            changeMonth: true,
            changeYear: true,
            autocomplete: "off",
            maxDate: new Date()
        });

        $("#myOrders_endDate").datepicker({
            dateFormat: "yy-mm-dd",
            changeMonth: true,
            changeYear: true,
            autocomplete: "off",
            maxDate: new Date()
        });

        function getPagedOrders(page, itemsPerPage, startDate, endDate, searchNumber = "") {
            $('#myOrders_itemsPerPage').val(itemsPerPage);
            $('#myOrders_startDate').val(startDate);
            $('#myOrders_endDate').val(endDate);
            $('#myOrders_searchNumber').val(searchNumber);
            $(".order-paginate").html($("<div>").addClass('order-details-data').html({}));

                if ($(myOrdersTab).length > 0) {
                    $(".order-details-empty").hide();
                    ordersLoading = true;

                    $.ajax({
                        url: $(myOrdersTab).data("orders-url"),
                        data: {pageNumber: page, itemsPerPage: itemsPerPage, startDate: startDate, endDate: endDate, searchNumber: searchNumber.trim()},
                        success: function (data) {
                            if ("" == data) {
                                $(".order-details-empty").show();
                            } else {
                                $(".order-paginate").html($("<div>").addClass('order-details-data').html(data));
                                initPrintInvoiceButton();
                                updatePaginationControls(page);
                            }
                        },
                        complete: function () {
                            ordersLoading = false;
                        }
                    });
                }
        }

        function updatePaginationControls(page) {
            $('#myOrders_prevPage').attr('disabled', page <= 1);
            $('#myOrders_nextPage').attr('disabled', page >= totalPages.value);

            if (totalPages.value > 1) {
                updatePageDropdown(totalPages.value, page);
                $('#myOrders_currentPage').hide();
                $('#myOrders_pageDropdown').show();
            } else {
                $('#myOrders_currentPage').text(page).show();
                $('#myOrders_pageDropdown').hide();
            }
        }

        function updatePageDropdown(totalPages, currentPage) {
            let pageDropdown = $('#myOrders_pageDropdown');
            pageDropdown.empty();

            for (let i = 1; i <= totalPages; i++) {
                let option = $('<option></option>').val(i).text(i);
                if (i === currentPage) {
                    option.attr('selected', 'selected');
                }
                pageDropdown.append(option);
            }
        }

        if ($(tabSel).hasClass("active")) {
            getPagedOrders(currentPage, itemsPerPage, startDate, endDate, searchNumber);
        }

        $(document).on('click', '#myOrders_prevPage', function () {
            if (currentPage > 1) {
                currentPage--;
                itemsPerPage = localStorage.getItem('itemsPerPage');
                getPagedOrders(currentPage, itemsPerPage, startDate, endDate, searchNumber);
            }
        });

        $(document).on('click', '#myOrders_nextPage', function () {
            if (currentPage <= totalPages.value) {
                currentPage++;
                itemsPerPage = localStorage.getItem('itemsPerPage');
                getPagedOrders(currentPage, itemsPerPage, startDate, endDate, searchNumber);
            }
        });

        $(document).on('change', '#myOrders_pageDropdown', function () {
            currentPage = parseInt($(this).val(), 10);
            getPagedOrders(currentPage, itemsPerPage, startDate, endDate, searchNumber);
        });

        $(document).on('change', '#myOrders_itemsPerPage', function () {
            let itemsPerPage = $(this).val();
            localStorage.setItem('itemsPerPage', itemsPerPage);
            currentPage = 1;
            getPagedOrders(currentPage, itemsPerPage, startDate, endDate, searchNumber);
        });

        $(document).on('keydown', '#myOrders_searchNumber', function (event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                $('#myOrders_filterButton').click();
            }
        });

        $(document).on('click', '#myOrders_filterButton', function () {
            startDate = $('#myOrders_startDate').val();
            endDate = $('#myOrders_endDate').val();

            isValidStartDate = isValidISODate(startDate);
            isValidEndDate = isValidISODate(endDate);

            if (!isValidStartDate || !isValidEndDate) {
                const errorMessage = !isValidStartDate
                    ? $('#myOrders_startDate').data('error-message')
                    : $('#myOrders_endDate').data('error-message');
                $('#myOrders_date_error_message').text(errorMessage).show();
                clearDates();

                return;
            }
            $('#myOrders_date_error_message').hide();

            localStorage.setItem('startDate', startDate);
            localStorage.setItem('endDate', endDate);

            searchNumber = $('#myOrders_searchNumber').val();
            localStorage.setItem('searchNumber', searchNumber);

            itemsPerPage = localStorage.getItem('itemsPerPage') || 10;
            currentPage = 1;
            getPagedOrders(currentPage, itemsPerPage, startDate, endDate, searchNumber);
        });

        $(document).on('click', '#myOrders_clearDatesButton', function () {
            clearDates();
            $("#myOrders_searchNumber").val('');
            $('#myOrders_filterButton').click();
        });
    };

    function isValidISODate(dateString) {
        if (dateString === '') {
            return true;
        }

        var regex = /^\d{4}-\d{2}-\d{2}$/;

        if (!dateString.match(regex)) {
            return false;
        }

        var date = new Date(dateString);
        var timestamp = date.getTime();

        if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
            return false;
        }

        return dateString === date.toISOString().split('T')[0];
    }

    function clearDates() {
        $("#myOrders_startDate").val('');
        $("#myOrders_endDate").val('');
    }

    var checkPreSelectTab = function() {
        var hash = window.location.hash;
        if (hash) {
            $('#myAccountTabs a[href="' + hash + '"]').tab('show');
        }
    };

    function resolveCancelOrderMessage(messageKey, rdNumber, responseMessageParametersByRdNumber) {
        if (!messageKey) {
            return null;
        }

        var template = null;
        switch (messageKey) {
            case "cancel.order.error.left_warehouse_ticket_created":
                template = $(".cancel-order-error-left-warehouse").first().text();
                break;
            case "cancel.order.error.already_cancelled":
                template = $(".cancel-order-error-already-cancelled").first().text();
                break;
            case "cancel.order.error.mismatched":
                template = $(".cancel-order-error-mismatched").first().text();
                break;
            case "cancel.order.error.cancellation_not_successful":
                template = $(".cancel-order-error-cancellation-not-successful").first().text();
                break;
            case "rdnr.too.old.for.cancel":
                template = $(".cancel-order-error-rdnr-too-old-for-cancel").first().text();
                break;
            case "cancel.order.ticket.created":
                template = $(".contact-form-error-ticket-created").first().text();
                break;
            case "cancel.order.ticket.already.created":
                template = $(".contact-form-error-ticket-already-created").first().text();
                break;
            default:
                template = null;
        }

        if (!template) {
            return null;
        }

        var rdParams = responseMessageParametersByRdNumber &&
            rdNumber &&
            responseMessageParametersByRdNumber[rdNumber];

        var ticketNumber = rdParams && rdParams.ticketNumber;
        if (ticketNumber !== null && ticketNumber !== undefined) {
            template = template.replace(/\{ticketNumber\}/g, String(ticketNumber));
            template = template.replace(/\{ticket\}/g, String(ticketNumber));
        }

        return template;
    }

    function handleCancelOrderStatus(data) {
        var responsesContainer = $(".cancel-order-response-container").first();
        var message;
        var status = data.status;

        if (status === "ERROR") {
            message = $(".cancel-order-error-default").first().text();
            responsesContainer.append($("<div>").addClass("error").text(message));
            responsesContainer.show();
            return;
        }

        var orderNumberPrefix = $(".order-number-prefix-message").first().text();
        var responseByRdNumber = data.responseByRdNumber;
        var responseMessageByRdNumber = data.responseMessageByRdNumber || {};
        var responseMessageParametersByRdNumber = data.responseMessageParametersByRdNumber || {};

        // Handle flat response structure (My Account API returns status and message directly)
        if (!responseByRdNumber) {
            var messageType = "error";
            // Read message key from the message field (Contact Form pattern)
            var messageKey = data.message || status;
            var resolvedMessage = resolveCancelOrderMessage(messageKey, null, responseMessageParametersByRdNumber);

            if (!status || status === "SUCCESS") {
                message = $(".cancel-order-success-message").first().text();
                messageType = "success";
            } else if (status === "DUPLICATE") {
                message = resolveCancelOrderMessage("cancel.order.ticket.already.created", null, responseMessageParametersByRdNumber)
                    || $(".contact-form-error-ticket-already-created").first().text()
                    || $(".cancel-order-error-default").first().text();
                messageType = "error";
            } else if (status === "FAILED") {
                message = resolvedMessage || $(".cancel-order-error-default").first().text();
            } else if (status === "CONFLICT") {
                message = $(".cancel-order-error-rdnr-mail-mismatch").first().text();
            } else if (status === "NOT_FOUND") {
                message = $(".cancel-order-error-rdnr-not-found").first().text();
            } else if (status === "TOKEN_EXPIRED") {
                // Use resolveCancelOrderMessage to get the localized text from the div
                message = resolveCancelOrderMessage("rdnr.too.old.for.cancel");
            } else {
                message = resolvedMessage || $(".cancel-order-error-default").first().text();
            }

            responsesContainer.append($("<div>").addClass(messageType).text(message));
            responsesContainer.show();
            return;
        }

        for (var rdNumber in responseByRdNumber) {
            if (!responseByRdNumber.hasOwnProperty(rdNumber)) {
                continue;
            }

            var messageType = "error";
            var rdNumberMessage;
            var response = responseByRdNumber[rdNumber];
            var responseMessage = responseMessageByRdNumber ? responseMessageByRdNumber[rdNumber] : null;
            responseMessage = resolveCancelOrderMessage(responseMessage, rdNumber, responseMessageParametersByRdNumber);

            if (!response) {
                message = $(".cancel-order-success-message").first().text();
                messageType = "success";
            } else if (response === "SUCCESS") {
                message = $(".cancel-order-success-message").first().text();
                messageType = "success";
            } else if (response === "DUPLICATE") {
                message = resolveCancelOrderMessage("cancel.order.ticket.already.created", rdNumber, responseMessageParametersByRdNumber)
                    || $(".contact-form-error-ticket-already-created").first().text()
                    || $(".cancel-order-error-default").first().text();
                messageType = "error";
            } else if (response === "FAILED") {
                message = responseMessage || $(".cancel-order-error-default").first().text();
            } else if (response === "CONFLICT") {
                message = $(".cancel-order-error-rdnr-mail-mismatch").first().text();
            } else if (response === "NOT_FOUND") {
                message = $(".cancel-order-error-rdnr-not-found").first().text();
            } else if (response === "TOKEN_EXPIRED") {
                message = $(".cancel-order-error-rdnr-too-old-for-cancel").first().text();
            } else {
                message = $(".cancel-order-error-default").first().text();
            }

            rdNumberMessage = orderNumberPrefix + " " + rdNumber + " - " + message;
            responsesContainer.append($("<div>").addClass(messageType).text(rdNumberMessage));
        }

        responsesContainer.show();
    }

    var initCancelOrder = function () {
        $(".my-account-cancel-order-form").on("submit", function (event) {
            event.preventDefault();

            var responsesContainer = $(".cancel-order-response-container").first();
            responsesContainer.hide();
            responsesContainer.empty();

            var orderCode = $("#my-account-cancel-order-code").val();
            var csrfToken = $("input[name='_csrf']").val();

            var submitButton = $(this).find("button[type='submit']");
            submitButton.prop("disabled", true);

            var payload = {};
            var reasonValue = $("#my-account-cancel-order-subtopic").val();
            if (reasonValue) {
                payload.reason = reasonValue;
            }

            var rdNumberToCancelInput = $("#my-account-cancel-order-rd-number");
            if (rdNumberToCancelInput.length) {
                payload.rdNumberToCancel = rdNumberToCancelInput.val();
            }

            $.ajax({
                url: "/my-account/cancel-order/" + orderCode,
                type: "POST",
                contentType: "application/json; charset=utf-8",
                headers: {
                    "X-CSRF-TOKEN": csrfToken
                },
                data: JSON.stringify(payload)
            }).done(handleCancelOrderStatus)
                .always(function () {
                    submitButton.prop("disabled", false);
                });
        });
    };

    return {
        initBindingActions: initBindingActions,
        errorsOnPageAction: errorsOnPageAction,
        initPaginate: initPaginate,
        checkPreSelectTab: checkPreSelectTab,
        initCancelOrder: initCancelOrder,
        initPrintInvoiceButton: initPrintInvoiceButton
    };


})(jQuery);

var ReifendirektMyAccountAddOnCheckoutJs = (function ($) {
    var getCheckoutLogin = function(button, currentPage) {
        $(button).on("click", function() {
            getCheckoutLoginForm(currentPage);
        });

        var loginError = $(currentPage).data("login-error");
        if (loginError === true) {
            getCheckoutLoginForm(currentPage);
        }
    };

    var getCheckoutLoginForm = function(currentPage) {
        $.ajax({
            url: $(currentPage).data("login-checkout-url"),
            type: "GET",
            cache: true,
            success: function(data) {
                $(currentPage).append(data);
                bindCheckoutForgottenPwd('.j-forgotten-pwd');
            },
            error: function(data) {
                console.log(data);
            }
        });
        $('.j-already-registered').hide();
    };

    var bindCheckoutForgottenPwd = function(button) {
        $(button).on("click", function(e) {
            if ($(button).data("regular-login") === false ) {
                e.preventDefault();
                $.ajax({
                    url: $(button).data("forgotten-pwd"),
                    type: "GET",
                    cache: true,
                    success: function(data) {
                        $.fancybox({width:500, height:500,
                            content: data,
                            fitToView: true,
                            autoSize: true,
                            helpers: {
                                overlay: {
                                    locked: false
                                }
                            }
                        });
                        bindCheckoutForgottenPassword(".j-fragment-forgotten-pass #forgottenPwdForm");
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            }
        });
    };

    var bindCheckoutForgottenPassword = function(formSelector) {
        $(formSelector).on("submit", function(e) {
            e.preventDefault();
            var $form = $(formSelector);

            $.ajax({
                url: $form.attr("action"),
                type: "POST",
                data: $form.serialize(),
                success: function(data) {
                    $(".j-fragment-forgotten-pass").html(data);
                    var element = $(data).find(".j-checkout-forgotten-pass-success");

                    if ($(element).length > 0) {
                        var delay = 2000;
                        setTimeout('$.fancybox.close();', delay);
                    }
                    bindCheckoutForgottenPassword(".j-fragment-forgotten-pass #forgottenPwdForm");
                }
            });
        });
    };

    return {
        getCheckoutLogin: getCheckoutLogin
    }

})(jQuery);

function reloadOrders(url) {
    //clean document of old orders
    $('#content_myOrders .order-details-data').remove();

    //reload
    ReifendirektMyAccountCleanAddOnJs.initPaginate('.orders-tab');
}

var ReifendirektMyAccountInitJs = (function ($) {
    var init = function() {
        ReifendirektMyAccountCleanAddOnJs.initBindingActions('.j-show-edit-form'
            ,'.j-cancel-edit-form'
            ,'.j-edit-form'
            ,'.j-view-form'
            ,'.j-form-container'
            ,'.j-submit-form'
            ,'.j-add-delivery-address'
            ,'.j-delete-delivery-address'
            ,'.j-delivery-address-list'
            ,'.j-add-my-car'
            ,'.j-delete-my-car'
            ,'.j-my-car-list');

        ReifendirektMyAccountCleanAddOnJs.errorsOnPageAction('.j-account-settings', '.j-view-edit');
        ReifendirektMyAccountCleanAddOnJs.initPaginate('.orders-tab');
        ReifendirektMyAccountAddOnCheckoutJs.getCheckoutLogin('.j-already-registered-button','.checkout-login');
        ReifendirektMyAccountCleanAddOnJs.checkPreSelectTab();
        ReifendirektMyAccountCleanAddOnJs.initCancelOrder();
        ReifendirektMyAccountCleanAddOnJs.initPrintInvoiceButton();

        $(document).ajaxStart(function () {
            $("#preLoading").show();
        }).ajaxStop(function () {
            $("#preLoading").hide();
        });

        var userAccountContainer = $(".user-account");
        var userAccountMenu = $(".user-account_quick-access-list");

        if (userAccountContainer.length) {
            // show - hide for mobile touch devices
            if (IsMobile.any()) {
                if ($("#aroTheme").val() !== "aro-lite") {
                    userAccountContainer.on('click touchstart', function () {
                        userAccountMenu.show();
                    });
                }
                $('html').on('touchstart', function() {
                    userAccountMenu.hide();
                });
                userAccountMenu.on('touchstart',function(e) {
                    e.stopPropagation();
                });
            }
            // show - hide for desktop
            else {
                userAccountContainer.on('mouseover', function () {
                    userAccountMenu.show();
                });
                userAccountContainer.on('mouseout', function () {
                    userAccountMenu.hide();
                });
            }
        }
    };

    var switchMyaccountTabs = function () {
        // Switch my account tabs
        var accountTopControls = $(".user-account_quick-access-list li a");
        if (accountTopControls.length) {
            accountTopControls.on('click', function (ev) {
                var selectedTabId = ev.target.getAttribute("href").split("#")[1];
                if (selectedTabId) {
                    $(".my-account-container .nav.nav-tabs.jTabs li.active").removeClass("active");
                    $(".my-account-container .nav.nav-tabs-left-list.jTabs li.active").removeClass("active");
                    $(".my-account-container .tab-content div.tab-pane").hide();
                    $("." + selectedTabId).trigger('click');
                }
            });
        }
    };

    return {
        init: init,
        switchMyaccountTabs: switchMyaccountTabs
    }

})(jQuery);

$(document).ready(function() {
    ReifendirektMyAccountInitJs.init();
    ReifendirektMyAccountInitJs.switchMyaccountTabs();
});

async function openCreditnotePdf(creditnoteUrl) {
    try {
        const response = await fetch(creditnoteUrl);

        if (!response.ok) {
            const errorText = await response.text();
            alert(errorText);
            return;
        }

        const base64 = await response.text();
        const binaryString = atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const newTab = window.open(url, "_blank");

        if (!newTab) {
            alert("Popup was blocked. Please allow popups for this site.");
            return; // intentionally added return, to exit early if popup is blocked
        } else {
            newTab.onload = () => {
                URL.revokeObjectURL(url);
            };
        }
    } catch (err) {
        console.error("Failed to open PDF:", err);
        alert("Error loading PDF: " + err.message);
    }
}